










































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import func from "@/ts/FormFunctions";
import fieldData from "@/ts/FormData";
import { IVueStateCollection } from "@/ts/FormBuilder";
import ErrorMessages from "@/ts/constants/ReportingErrorMessages";
import { IMaterialItemVueModel } from "@/ts/models/IMaterialItemVueModel";
import { IRecyclingActivitiesVueModel } from "@/ts/models/IRecyclingActivitiesVueModel";

@Component({
    props: {
        form: {
            type: Object as () => IRecyclingActivitiesVueModel
        },
        vueStates: {
            type: Object as () => IVueStateCollection
        },
        isReadOnly: {
            type: Boolean
        }
    }
})
export default class RecyclingActivitiesMaterials extends Vue {
    name: string = "RecyclingActivitiesMaterials";
    title: string = "";

    errorMsgs = ErrorMessages;
    unitsOfMeasure = fieldData.unitsOfMeasure;
    recycledMaterials = fieldData.recycledMaterials;
    nonRecycledMaterials = fieldData.nonRecycledMaterials;
    materialMeasures = fieldData.materialMeasures;

    mounted(): void {
        this.title = this.$props.vueStates.views[1].name;

        this.$emit("update:title", this.title);
        this.$emit("update:currentIndex", 1);

        this.$watch("hasErrors", (n, o) => {
            this.$props.vueStates.views[1].error = this.hasErrors;
        }, { immediate: true });

        this.$props.vueStates.views[1].visited = true;
    }

    get hasRecyclableMaterialErrors(): boolean {
        let materials = this.$props.form.recyclableMaterials as IMaterialItemVueModel[];
        return materials.some((m, ix, arr) => this.isRecyclableError(ix));
    }

    isRecyclableNameError(index: number): boolean {
        return func.isNullOrEmpty(this.$props.form.recyclableMaterials[index].name);
    }

    isRecyclableOverrideNameError(index: number): boolean {
        if (this.$props.form.recyclableMaterials[index].name != 'Other') return false;

        return func.isNullOrEmpty(this.$props.form.recyclableMaterials[index].overrideName);
    }

    isRecyclableAmountError(index: number): boolean {
        return func.isNullOrEmptyOrZero(this.$props.form.recyclableMaterials[index].amount) || (this.$props.form.recyclableMaterials[index].amount as number) * 1 <= 0;
    }

    isRecyclableMeasureError(index: number): boolean {
        return func.isNullOrEmpty(this.$props.form.recyclableMaterials[index].measure);
    }

    private isRecyclableError(index: number): boolean {
        return this.isRecyclableNameError(index) || this.isRecyclableAmountError(index) || this.isRecyclableMeasureError(index);
    }

    addRecyclableMaterial(): void {
        this.$props.form.recyclableMaterials.push(fieldData.reportingMaterials.emptyMaterialItem);
    }

    removeRecyclableMaterial(index: number): void {
        let materials = this.$props.form.recyclableMaterials as IMaterialItemVueModel[];
        //let index = materials.map((item) => item.id).indexOf(materialId);
        materials.splice(index, 1);
    }

    get hasNonRecyclableMaterialErrors(): boolean {
        let materials = this.$props.form.nonRecyclableMaterials as IMaterialItemVueModel[];
        return materials.some((m, ix, arr) => this.isNonRecyclableError(ix));
    }

    isNonRecyclableNameError(index: number): boolean {
        return func.isNullOrEmpty(this.$props.form.nonRecyclableMaterials[index].name);
    }

    isNonRecyclableOverrideNameError(index: number): boolean {
        if (this.$props.form.nonRecyclableMaterials[index].name != 'Other') return false;

        return func.isNullOrEmpty(this.$props.form.nonRecyclableMaterials[index].overrideName);
    }

    isNonRecyclableAmountError(index: number): boolean {
        return func.isNullOrEmptyOrZero(this.$props.form.nonRecyclableMaterials[index].amount);
    }

    isNonRecyclableMeasureError(index: number): boolean {
        return func.isNullOrEmpty(this.$props.form.nonRecyclableMaterials[index].measure);
    }

    get isTotalMaterialError(): boolean {
        return this.$props.form.recyclableMaterials.length + this.$props.form.nonRecyclableMaterials.length <= 0;
    }

    private isNonRecyclableError(index: number): boolean {
        return this.isNonRecyclableNameError(index) || this.isNonRecyclableAmountError(index) || this.isNonRecyclableMeasureError(index);
    }

    addNonRecyclableMaterial(): void {
        this.$props.form.nonRecyclableMaterials.push(fieldData.reportingMaterials.emptyMaterialItem);
    }

    removeNonRecyclableMaterial(index: number): void {
        let materials = this.$props.form.nonRecyclableMaterials as IMaterialItemVueModel[];
        //let index = materials.map((item) => item.id).indexOf(materialId);
        materials.splice(index, 1);
    }

    resetRecyclableOverrideName(index: number) {
        if (this.$props.form.recyclableMaterials[index].name != 'Other') {
            this.$props.form.recyclableMaterials[index].overrideName = '';
        }
    }

    resetNonRecyclableOverrideName(index: number) {
        if (this.$props.form.nonRecyclableMaterials[index].name != 'Other') {
            this.$props.form.nonRecyclableMaterials[index].overrideName = '';
        }
    }

    get hasErrors(): boolean {
        return this.hasRecyclableMaterialErrors || this.hasNonRecyclableMaterialErrors || this.isTotalMaterialError;
    }
}
